import { render } from "./Cars.vue?vue&type=template&id=24cfa893"
import script from "./Cars.vue?vue&type=script&lang=js"
export * from "./Cars.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__